export const MESSAGE_KEY_TOGGLE_OFF = 'MESSAGE_KEY_TOGGLE_OFF';
export const MESSAGE_KEY_TOGGLE_ON = 'MESSAGE_KEY_TOGGLE_ON';
export const MESSAGE_KEY_CHANGE_THRESHOLD = 'MESSAGE_KEY_CHANGE_THRESHOLD';
export const MESSAGE_KEY_TOGGLE_SHADOW = 'MESSAGE_KEY_TOGGLE_SHADOW';
export const MESSAGE_KEY_CHANGE_DEPOL = 'MESSAGE_KEY_CHANGE_DEPOL';
